import React from "react";
import { Outlet } from "react-router";
import { useOrgContext } from "@/contexts/OrgContext";

export function OrgUserLayout() {
  let orgRole: string | null | undefined;
  try {
    ({ orgRole } = useOrgContext());
  } catch {
    // Context not ready yet (e.g. loading)
    return (
      <div className="p-8 text-center text-muted-foreground">
        Loading organisation…
      </div>
    );
  }

  // Any orgRole is allowed ("ADMIN", "USER", "VIEWER", etc)
  if (!orgRole) {
    return (
      <div className="p-8 text-center text-destructive">
        You need to be a member of an organisation to view this page.
      </div>
    );
  }

  return <Outlet />;
}
